import {
  AllyListResponse,
  FiscalInfoResponse
} from '@/modules/allies/allies/services/apiValidationSchemas'
import { AllyDetailsDTO } from '@/modules/allies/allies/types/Ally.ts'
import { MonthlyChargeVerificationResponse } from '@/modules/allies/monthlyCut/services/apiValidations/monthlyChargeVerificationApiValidation.ts'

export const alliesList: { data: AllyListResponse; message: string } = {
  message: 'OK',
  data: {
    results: [
      {
        id: '2',
        name: 'Anacleta perez',
        phone: '0123456789',
        email: 'ana@gmail.com',
        sectorId: 2,
        sectorName: '',
        stateId: 1,
        stateName: 'EL paso',
        cityId: 1,
        cityName: 'El paso',
        availableBalance: '500',
        canAssignProducts: true,
        commission: '2',
        uniqueIdentifier: '45545-GTG',
        walletId: '324234234',
        canAssignMiscellaneous: false
      }
    ],
    total: [],
    status: true,
    pagination: {
      next: false,
      prev: false,
      start: 1,
      limit: 20,
      end: 1,
      range: [1],
      count: 2,
      pages: 1,
      total: 1
    }
  }
}

export const allyDetail: { data: AllyDetailsDTO } = {
  data: {
    id: 2,
    name: 'Grisel',
    phone: '+58123456788',
    email: 'genamorado88@gmail.com',
    identityNumber: '123456'
  }
}

export const alliesCatalog = {
  message: 'OK',
  data: [
    {
      id: '3',
      label: 'Aliado 1'
    },
    {
      id: '4',
      label: 'Aliado 2'
    },
    {
      id: '2',
      label: 'Aliado 3'
    },
    {
      id: '5',
      label: 'Aliado 4'
    },
    {
      id: '1',
      label: 'Aliado 5'
    }
  ]
}

export const commercialAlliesTypeCatalog = {
  message: 'OK',
  data: [
    {
      id: '2S',
      label: '2S'
    },
    {
      id: 'AD',
      label: 'AD'
    },
    {
      id: 'BO',
      label: 'BO'
    }
  ]
}

export const allyBankAccount = {
  message: 'OK',
  data: {
    results: [
      {
        id: '2',
        isMain: true,
        accountNumber: '01020497630000835128',
        beneficiary: 'sdasd',
        rifLetter: 'P',
        rifNumber: '324344',
        commercialAllyId: '1',
        commercialAllyName: 'WEPPA',
        commercialAllyBankAccountTypeId: '1',
        commercialAllyBankAccountTypeName: 'Corriente',
        isActive: true
      },
      {
        id: '6',
        isMain: false,
        accountNumber: '01910184312100038506',
        beneficiary: 'WEPPA GROUP INVESTMENS',
        rifLetter: 'J',
        rifNumber: '504865052',
        commercialAllyId: '1',
        commercialAllyName: 'WEPPA',
        commercialAllyBankAccountTypeId: '1',
        commercialAllyBankAccountTypeName: 'Corriente',
        isActive: true
      }
    ],
    total: [],
    status: true,
    pagination: {
      next: false,
      prev: false,
      start: 1,
      end: 2,
      range: [1],
      count: 2,
      pages: 1,
      total: 2,
      limit: 20
    }
  },
  status: 200
}

export const commercialAllyBankAccount = {
  data: {
    id: '6',
    isMain: false,
    accountNumber: '01910184312100038506',
    beneficiary: 'WEPPA GROUP INVESTMENS',
    rifLetter: 'J',
    rifNumber: '504865052',
    commercialAllyId: '1',
    commercialAllyName: 'WEPPA',
    commercialAllyBankAccountTypeId: '1',
    commercialAllyBankAccountTypeName: 'Corriente',
    isActive: true
  },
  status: 200
}

export const fiscalInfo: { data: FiscalInfoResponse } = {
  data: {
    commercialAllyId: '5',
    taxStatus: 'Contribuyente Especial-test',
    businessName: 'Inversiones Tecnológicas WEPPA C.A.',
    isCompany: true,
    state: 'Miranda',
    city: 'Caracas',
    postalCode: '1060',
    address: 'Av. Francisco de Miranda, Torre W, Piso 12',
    phone: '+582125554433',
    email: 'administracion@weppa-tech.com',
    rif: 'J-123456789',
    latitude: '3432325',
    longitude: '4646456'
  }
}

export const validateMonthlyCharges: {
  data: MonthlyChargeVerificationResponse
} = {
  data: {
    exists: false,
    year: 2026,
    month: 3,
    details: 'No hay registros previos.'
  }
}

export const commercialAllyPage1 = {
  message: 'OK',
  data: {
    results: [
      {
        id: '509',
        isMain: true,
        accountNumber: '01020000000000000508',
        beneficiary: 'Beneficiario_508',
        rifLetter: 'V',
        rifNumber: '3a5a0d70661122e0ef9beb1b70d354fd',
        commercialAllyId: '1',
        commercialAllyName: 'Ally_Nadia',
        commercialAllyBankAccountTypeId: '1',
        commercialAllyBankAccountTypeName: 'Corriente ',
        isActive: true
      },
      {
        id: '510',
        isMain: true,
        accountNumber: '00000000000000000508',
        beneficiary: 'Beneficiario_508',
        rifLetter: 'V',
        rifNumber: '3a5a0d70661122e0ef9beb1b70d354fd',
        commercialAllyId: '1',
        commercialAllyName: 'Ally_Nadia',
        commercialAllyBankAccountTypeId: '1',
        commercialAllyBankAccountTypeName: 'Corriente ',
        isActive: true
      }
    ],
    total: [],
    status: true,
    pagination: {
      next: false,
      prev: false,
      start: 1,
      end: 1,
      range: [1],
      count: 1,
      pages: 1,
      total: 1,
      limit: 10
    }
  },
  status: 200
}

export const cashoutAllyPage1 = {
  message: 'OK',
  data: {
    results: [
      {
        id: '547',
        debt: '59.33',
        amount: '59.33',
        amountBs: '15726.60',
        exchange: '265.07',
        status: 'PENDIENTE',
        commercialAllyName: 'Ally_323',
        createdAt: '08\/12\/2025',
        updatedAt: null,
        createdBy: null,
        accountNumber: '00000000000000000041',
        commercialAllyId: '326'
      },
      {
        id: '546',
        debt: '419.76',
        amount: '419.76',
        amountBs: '111265.78',
        exchange: '265.07',
        status: 'PENDIENTE',
        commercialAllyName: 'Ally_127',
        createdAt: '08\/12\/2025',
        updatedAt: null,
        createdBy: null,
        accountNumber: '00000000000000000052',
        commercialAllyId: '129'
      }
    ],
    total: [],
    status: true,
    pagination: {
      next: false,
      prev: false,
      start: 1,
      end: 2,
      range: [1],
      count: 2,
      pages: 1,
      total: 2,
      limit: 100
    }
  },
  status: 200
}

export const branchOfficesPage1 = {
  message: 'OK',
  data: {
    results: [
      {
        id: '1',
        name: 'Pc4shop Galerias Avila',
        email: 'info@pc4shop.com',
        phone: '04241648796',
        address:
          'Local P81, C.C Galerias Avila Nivel Parque, Av. Urdaneta, Caracas 1011, Distrito Capital, Venezuela',
        isActive: true,
        commercialAllyId: '1',
        commercialAllyName: 'Ally_Nadia',
        sectorId: 1,
        sectorName: 'CENTRO HISTORICO',
        trademarkId: '1',
        trademarkName: 'Pc4shop',
        instagramChannel: 'https:\/\/www.instagram.com\/pc4shop\/',
        facebookChannel: null,
        whatsappChannel: '04241648796',
        canAssignMiscellaneous: true
      },
      {
        id: '2',
        name: 'Pc4shop Millenium Mall',
        email: 'info@pc4shop.com',
        phone: '04241648796',
        address:
          'Centro Empresarial Millennium Mall, Av R\u00f3mulo Gallego C.C, Nivel C3-09 Urb, Caracas, Distrito Capital, Venezuela',
        isActive: true,
        commercialAllyId: '1',
        commercialAllyName: 'Ally_Nadia',
        sectorId: 1,
        sectorName: 'CENTRO HISTORICO',
        trademarkId: '1',
        trademarkName: 'Pc4shop',
        instagramChannel: 'https:\/\/www.instagram.com\/pc4shop\/',
        facebookChannel: null,
        whatsappChannel: '04241648796',
        canAssignMiscellaneous: false
      },
      {
        id: '1700',
        name: 'test',
        email: 'test@gmail.com',
        phone: '464646',
        address: null,
        isActive: true,
        commercialAllyId: '1',
        commercialAllyName: 'Ally_Nadia',
        sectorId: 408,
        sectorName: 'LA ESMERALDA',
        trademarkId: '1034',
        trademarkName: 'Nadia',
        instagramChannel: null,
        facebookChannel: null,
        whatsappChannel: null,
        canAssignMiscellaneous: false
      }
    ],
    total: [],
    status: true,
    pagination: {
      next: false,
      prev: false,
      start: 1,
      end: 3,
      range: [1],
      count: 3,
      pages: 1,
      total: 3,
      limit: 20
    }
  },
  status: 200
}

export const branchOfficeDetail = {
  data: {
    id: '1700',
    name: 'test',
    email: 'test@gmail.com',
    phone: '464646',
    address: null,
    isActive: true,
    commercialAllyId: '1',
    commercialAllyName: 'Ally_Nadia',
    sectorId: 408,
    sectorName: 'LA ESMERALDA',
    trademarkId: '1034',
    trademarkName: 'Nadia',
    instagramChannel: null,
    facebookChannel: null,
    whatsappChannel: null,
    accessSchedule: {
      startTime: '09:00',
      endTime: '18:00'
    }
  },
  status: 200
}

export const monthlyCut = {
  message: 'Reporte mensual obtenido correctamente.',
  data: {
    results: [
      {
        id: '5eff63ec-4f6a-bac9-7cf1-6482d94c5218',
        commercialAllyId: '411',
        year: 2026,
        month: 4,
        total: '-8.26',
        odoo: '-7.12',
        iba: '-1.14',
        productsTotalInitial: '0.00',
        commercialAllyName: 'Ally_407',
        productsSoldQuantity: 0,
        productsSoldAmount: '0.00',
        productsSoldCommission: '0.00',
        productsReturnAmount: '236.00',
        productsReturnCommission: '8.26',
        productsChangeAmount: '0.00',
        productsChangeCommission: '0.00',
        productsEditionAmount: '0.00',
        productsEditionCommission: '0.00',
        quotesFeesAmount: '0.00',
        allyCommission: '3.50',
        income: '8.26',
        expenses: '236.00',
        exchange: '352.72',
        finalOdoo: -2511.37,
        totalBs: -2913.47,
        odooBs: -2511.61,
        ivaBs: -401.86
      },
      {
        id: '647e5107-6ac4-df0a-8f06-3a58f6fe12c4',
        commercialAllyId: '179',
        year: 2026,
        month: 4,
        total: '-4.97',
        odoo: '-4.28',
        iba: '-0.69',
        productsTotalInitial: '0.00',
        commercialAllyName: 'Ally_177',
        productsSoldQuantity: 0,
        productsSoldAmount: '0.00',
        productsSoldCommission: '0.00',
        productsReturnAmount: '142.00',
        productsReturnCommission: '4.97',
        productsChangeAmount: '0.00',
        productsChangeCommission: '0.00',
        productsEditionAmount: '0.00',
        productsEditionCommission: '0.00',
        quotesFeesAmount: '0.00',
        allyCommission: '3.50',
        income: '4.97',
        expenses: '142.00',
        exchange: '352.72',
        finalOdoo: -1509.64,
        totalBs: -1753.02,
        odooBs: -1511.22,
        ivaBs: -241.8
      }
    ],
    total: {
      productsSoldQuantity: '0',
      productsSoldAmount: '0.00',
      productsSoldCommission: '0.00',
      productsReturnAmount: '378.00',
      productsReturnCommission: '13.23',
      productsChangeAmount: '0.00',
      productsChangeCommission: '0.00',
      productsEditionAmount: '0.00',
      productsEditionCommission: '0.00',
      quotesFeesAmount: '0.00',
      income: '13.23',
      expenses: '378.00'
    },
    status: true,
    pagination: {
      next: false,
      prev: false,
      start: 1,
      end: 2,
      range: [1],
      count: 2,
      pages: 1,
      total: 2,
      limit: 20
    }
  },
  status: 200
}

export const commissionsByProductType = {
  data: {
    id: 1,
    commission: '10.50',
    isActive: true,
    commercialAllyId: 2,
    commercialAllyName: 'Aliado Principal',
    productTypeId: 2,
    productTypeName: 'Teléfono'
  }
}

export const commissionsByProductTypeList = {
  message: 'OK',
  data: {
    results: [
      {
        id: 1,
        commission: '10.50',
        isActive: true,
        commercialAllyId: 2,
        commercialAllyName: 'Aliado Principal',
        productTypeId: 2,
        productTypeName: 'Teléfono'
      },
      {
        id: 2,
        commission: '5.00',
        isActive: false,
        commercialAllyId: 2,
        commercialAllyName: 'Aliado Principal',
        productTypeId: 3,
        productTypeName: 'Computadora'
      }
    ],
    total: [],
    status: true,
    pagination: {
      next: false,
      prev: false,
      start: 1,
      end: 2,
      range: [1],
      count: 2,
      pages: 1,
      total: 2,
      limit: 20
    }
  },
  status: 200
}

export const checkMonthlyCut = {
  message: 'Consulta realizada con \u00e9xito',
  data: {
    exists: true,
    year: 2026,
    month: 6,
    details: 'Ya existe un registro de facturaci\u00f3n para este periodo.'
  },
  status: 200
}
